
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Ini disediakan oleh
                    <a href="${0}">Proyek Folksonomy Engine</a>. Jangan
                    ragu untuk berpartisipasi atau memberikan masukan`,
'h5d824b4954e56ea5': html`Pindai <span class="everyday">makanan </span> <span class="foods">sehari-hari</span>Anda`,
'h6bdd1b427aa985a4': html`Alat ini memungkinkan Anda untuk mengoreksi daftar bahan. Anda dapat menambahkan, menghapus, atau mengedit daftar bahan
                .
                <br>
                Karakter ini <span class="highlight">␣</span> mewakili spasi.
                <br>
                Karakter ini <span class="highlight">↩︎</span> mewakili jeda baris. `,
'hb28f1f2ec1744ee9': html`Properti-properti ini dibuat dan disimpan oleh pengguna untuk berbagai keperluan. Silakan
                    tambahkan properti Anda sendiri. Properti dan nilai yang Anda buat
                    <strong>harus akurat</strong>. Anda dapat melihat
                    <a href="${0}">daftar properti yang sudah digunakan oleh komunitas</a>
                    atau jelajahi
                    <a href="${1}">dokumentasi properti dan mesin pencari</a>.`,
's000a5b76bd3a01c2': `Memuat properti...`,
's000d98595e959c1e': `Dapatkan di Google Play`,
's013bdc8cf0d3583d': `Bantu kami untuk bahan-bahannya`,
's01d2865e3e1d5501': `Terima kasih atas bantuannya!`,
's02ce7a2e7c1b020b': `Validasi tanaman`,
's03e9c8114521b998': `Saya akan mengedit bahan-bahannya`,
's05ec315d9308091a': `Ikon sudut kode batang`,
's061eb5af92512c85': `Tersimpan! Bisakah Anda membantu dengan yang lainnya?`,
's06847c221c4c0bc1': `Saya ingin membuat properti untuk [menggambarkan kasus penggunaan Anda]...`,
's06f6c6f99db6b552': `Asli`,
's081e2ad82db71e1d': `Nilai yang Dikelompokkan`,
's09205907b5b56cda': `Tidak`,
's0b4235aae602a950': `dokumentasi khusus`,
's0bb2d48532acc455': `Unduh CSV`,
's0d5b7fee0311db68': `Properti`,
's0fb218abc2e157ed': `Batalkan gambar`,
's100c4928cc74642a': `mendukung kemajuan penelitian kesehatan masyarakat.`,
's10db5498186c083b': `Batalkan pemotongan`,
's11a18a69b30b65ed': `Bantu kami memperbaiki kesalahan dalam daftar bahan`,
's1205d5f6fccf8e69': `Nilai Properti`,
's15d64a0a6715285a': `Kunci baru`,
's166bd56d19670a72': `Perbesar`,
's19059bf0c4f7c162': `Area pemilihan`,
's1a52515ec8ddade8': `Barcode produk`,
's1c5031113de500ce': `menjaga basis data kami tetap terbuka &amp; tersedia untuk semua,`,
's1dc4daf989c71284': `Bantu kami mengoreksi informasi nutrisi`,
's1e00019dc454872d': `Harap berikan nama properti menggunakan atribut property-name.`,
's1e49126af0935a5b': `Daftar produk yang menggunakan properti ini`,
's21e73088de6f26f3': `Unduh di App Store`,
's255857544a9d5ec0': `Atur ulang`,
's25e94495991e95ba': `Terima kasih atas bantuannya! Bisakah Anda membantu dengan pertanyaan lain?`,
's2ceb11be2290bb1b': `Batalkan`,
's2db7b654c0a9bde0': `Dokumentasikan properti`,
's300b3a6ee4e1252d': str`Kecocokan Buruk ${0}%`,
's33f786bb6b4f0cf4': `Hasil Panen`,
's33f85f24c0f5f008': `Simpan`,
's34be4af4e8fec4ae': `Tanyakan pada komunitas terlebih dahulu`,
's36d86adc823cbfa6': `Sebelum membuat properti baru, diskusikan dengan komunitas:`,
's3781d25aa51a736c': `Dokumentasi Mesin Folksonomi`,
's383ae4449428b61e': `Setel ulang tanaman`,
's39bcf88721a1e8ee': `Setel ulang pilihan`,
's39e14e14300694c7': `Dokumentasi dan Pedoman`,
's3b430cfa5c1fe7f4': str`Dokumentasi untuk ${0}`,
's3f4e4b52f230a892': `Kanvas gambar`,
's417b90913e05bc17': `Pratinjau`,
's41f7dca46d3f1b4a': `Nilai`,
's422bba9636ce2489': `Gambar tengah`,
's42dd66b2441566fd': `Ikon tengah`,
's43df2e8395f6834e': str`Silakan berdonasi ke ${0} acara penggalangan dana kami`,
's453188ea728f64da': `Tambahkan nutrisi`,
's453ab0dbb9b5c777': `Ubah ukuran ke kanan`,
's475b08749d0706ed': `Bantu kami menginformasikan kepada jutaan konsumen di seluruh dunia tentang apa yang mereka makan`,
's49730f3d5751a433': `Memuat...`,
's4bbc7472834a9686': `Browser Anda tidak mendukung pemindaian barcode.`,
's4d42cc7e00076a3b': `Jumlah Produk`,
's4df2f533c0c1e7d0': `Kontrol gambar`,
's4e94adf723979402': `Open Food Facts membutuhkan bantuan Anda untuk produk ini.`,
's4f4886341969d552': `Pindahkan pilihan`,
's4f751fb9b3ed766c': `Membuat Properti Baru`,
's547c12ae169d00bc': `Tersedia di F-Droid`,
's5560fb119e40923d': `Masukkan nama properti...`,
's55d7249883a98ca1': `tentang properti ini di wiki Open Food Facts`,
's565867d84c04aea2': `Filter properti...`,
's5666afe5cd0166de': `Harap perbaiki kesalahan atau ubah teks sebelum mengonfirmasi`,
's57472465a23b41db': `Nilai`,
's58e1eeea7a60ae51': `Memuat produk...`,
's59df20feee978e5b': `Eror: Nilai tidak valid.`,
's5c92c0051d44b6de': `Bantu kami mengoreksi informasi nutrisi.`,
's5dd6f12783fca34f': `Edit daftar bahan`,
's5e8250fb85d64c23': `Tutup`,
's5ed03bb1f3a15949': `Gambar`,
's6306a31415aea913': `SAYA MENDUKUNG`,
's6498dfe4855bb3a7': `satuan`,
's64ef2a6c2dd1d3d1': `Sunting`,
's66413c24dcf680e2': `Lewati`,
's67ae6594857a4d57': `Terima kasih atas kontribusi Anda!`,
's6cee7cad81dfedd1': `Gambar yang dipotong`,
's6d7b6cdedaadfb6e': `Setiap donasi sangat berarti! Kami menghargai dukungan Anda dalam mewujudkan transparansi pangan di dunia.`,
's7124dde792a8faa2': `APK Android`,
's718dea04853f80ae': str`Cocok ${0}%`,
's71a5c9f4b68ef4d4': `Hitung`,
's74cb3d66f6a668e1': `Dokumentasi`,
's787dd11bed0dc88a': `Ubah ukuran kiri`,
's7ce4fd9430e80cea': `nilai`,
's801a05fa8e881f37': `Pelajari lebih lanjut tentang pembuatan properti dan panduannya:`,
's8038273de2cf8b73': `Silakan pilih wilayah yang akan dipotong.`,
's839cc2908a5387f2': `Saring kode batang...`,
's86197dcf3e96af64': `Jelajahi dan cari properti yang ada`,
's8a63be30a129a59c': `Ubah ukuran bagian bawah`,
's8a8bfd67f2dd2810': `Unduh aplikasi OFF dengan kode QR ini`,
's8af61807443f32a4': `Tindakan`,
's8b33c244759d7bd4': `Ubah ukuran kanan atas`,
's8db84aa4bc949af2': `Dokumentasikan Properti Baru`,
's8f839a03997a16d7': `Lihat Produk`,
's901ae1e236ac45d3': `Batalkan penghapusan`,
's907f7a97c6b29425': `Ketahuilah bahwa model data mungkin dimodifikasi. Gunakan dengan risiko Anda sendiri.`,
's95d23d03f9147581': `Perkecil`,
's976dfd19ef58a1e1': `Klik untuk memindai kode batang dan lihat detailnya (kesehatan, preferensi, dll.)`,
's98ff35f2a00dc60d': `Bahan-bahan :`,
's9a7f60fce090ecaf': `Gagal memuat properti. Silakan coba lagi nanti.`,
's9b87abd68fb9df45': `Tidak ditemukan? Buat kunci baru {value}`,
's9c0f52425fd2f07e': `Mungkin Tidak Cocok`,
's9fc41f789c63b40d': `Produk - produk`,
'sa1fa766e0d5634d7': `Tidak Ada Skor Tersedia`,
'sa548778b24054030': `Jelajahi semua properti yang disumbangkan dari proyek Folksonomy Engine. Properti ini menyediakan metadata dan wawasan tambahan tentang produk-produk dalam basis data Open Food Facts.`,
'sa63907958bd0ec4b': `Ubah ukuran kiri atas`,
'sa95b4224f685a36a': `Tutup modal`,
'sab56a1d439576fd6': `Ikon saran`,
'sac47ea2901d04c15': `Ubah ukuran kiri bawah`,
'sb125227d436c2925': `Cari konsep properti Anda di database properti yang ada:`,
'sb125568d43642e6f': `Menjawab pertanyaan tentang produk.`,
'sb1c538e038f9b214': str`Pertandingan Sangat Bagus ${0}%`,
'sb28639570ff3b852': `daftar semua properti`,
'sb3bdd638a58d30f4': `melibatkan komunitas warga yang berkomitmen,`,
'sb3cbcc1bd0fff140': `Setelah Anda memverifikasi bahwa properti Anda tidak ada dan komunitas setuju bahwa properti itu berguna, Anda perlu mendokumentasikannya terlebih dahulu di wiki.`,
'sb3d4f79d9d8b71e5': `Kirim`,
'sb560fa37a7bfb6c2': `Tidak ada produk yang ditemukan untuk properti ini.`,
'sb7f72e4c8a2d3357': `Nilai filter...`,
'sb8178320160f84ea': `Tampilkan hasil panen`,
'sbad7d2734149470b': `Validasikan`,
'sbb623d6b18d966a0': `Informasi nilai gizi ditampilkan pada kemasan:`,
'sbd6be5cde472f37c': `Semua wawasan telah terjawab! Terima kasih atas bantuan Anda!`,
'sbd9a0b2293b3cd3c': `Takaran saji`,
'sbe472dc3c2685985': `Nilai yang Sesuai`,
'sc0520e1732a5c568': `Besarkan gambar`,
'sc0cc559e7ede852a': `Ubah ukuran atas`,
'sc1c08d0cbcc3bd24': `Tidak Cocok`,
'sc52696641af72b53': `Instal aplikasi ini!`,
'sc5575e3107f87874': `Putar gambar ke kiri`,
'sc57b630a7a70c61f': `Perbaikan yang disarankan`,
'sc681b137e8f604f7': `Konfirmasi penghapusan`,
'sc6daf8a31883f8b9': `Pindahkan gambar`,
'sc895972c88d38ca5': `Properti Folksonomi`,
'sca0c3305aff570b8': str`per sajian yang ditentukan "${0}"`,
'scace072bef961918': `Baris`,
'scb3b0671d7b7f640': `Nilai baru`,
'scb489a1a173ac3f0': `Ya`,
'scbab4bd737ba7934': str`foto grup donasi ${0}`,
'scd21019c3cd618f3': `Bergabunglah dalam Diskusi Slack`,
'scdb6cad0b92721bf': `Tidak ada properti yang ditemukan.`,
'scf23a05631f93732': `Konfirmasi Hapus`,
'scfed2f270ef6a3aa': `Pilih area`,
'sd1022bc1ef9204f7': `Gambar yang dapat diperbesar`,
'sd1077c055cf9ba6b': `Bantu kami memvalidasi daftar bahan produk.`,
'sd698d21ddecba56b': `Hai! Anda dapat membantu kami meningkatkan informasi produk dengan menjawab pertanyaan berikut:`,
'sd82bc2decefa621b': `tetap independen pada industri makanan,`,
'sdb97e5976482606e': `Periksa apakah properti sudah ada`,
'sdbf806fefc584115': `Anda harus menemukan`,
'sdc673e73b5c13aea': `Hapus`,
'sdc792b75f1edcaba': `Bantu kami mengoreksi ejaan bahan-bahan.`,
'sdca5deead576ceee': `Ubah ukuran kanan bawah`,
'sdcc2555c5dde524f': `Yakin ingin menghapus item ini? Tindakan ini tidak dapat dibatalkan.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Membatalkan`,
'se5127cf0f92e7e48': `Tip: Anda juga dapat menemukan`,
'se773f50d2a16d481': `Putar gambar ke kanan`,
'sebb2c6c830a44574': `infrastruktur teknis (situs web/aplikasi seluler) &amp; tim kecil permanen`,
'sec6377f3c4e9b28c': `Saya akan mengusulkan hasil panen yang lebih baik`,
'seea3800e27baa686': `Produk Individu`,
'sefaba4adc4ec9219': `Properti Folksonomi`,
'seffa8ca49175b5f0': `Properti yang dipersonalisasi`,
'sf44a6b3b232c28ea': str`Ganti nilai saat ini dengan ${0}`,
'sf4cd86a2f5ef2588': `Kode Batang Produk`,
'sf57a61152168cc81': `Bantu kami memperbaiki deteksi bahan`,
'sf88b90b8ba23871c': `Pertandingan Tidak Diketahui`,
'sf9aee319a006c9b4': `Tambahkan`,
'sfacbbe968fa7d773': `Nama properti:`,
'sfc40ea3d5d5aa6f8': `Donasi Anda mendanai operasional sehari-hari asosiasi nirlaba kami:`,
'sfe87465d50530725': `Nilai yang sesuai`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  